import * as types from '../../lib/actionTypes.es6';


// PARTNER CONFIG
export function getPartnerConfigsRequest(payload) {
  return {
    type: types.GET_PARTNER_CONFIGS_REQUEST,
    payload,
  };
}

export function getPartnerConfigsFailure(error) {
  return {
    type: types.GET_PARTNER_CONFIGS_FAILURE,
    payload: error,
  };
}

export function getPartnerConfigsSuccess(response) {
  return {
    type: types.GET_PARTNER_CONFIGS_SUCCESS,
    payload: response,
  };
}

// PARTNER CONFIG EMAIL
export function getPartnerEmailConfigsRequest(payload) {
  return {
    type: types.GET_PARTNER_EMAIL_CONFIGS_REQUEST,
    payload,
  };
}

export function getPartnerEmailConfigsFailure(error) {
  return {
    type: types.GET_PARTNER_EMAIL_CONFIGS_FAILURE,
    payload: error,
  };
}

export function getPartnerEmailConfigsSuccess(response) {
  return {
    type: types.GET_PARTNER_EMAIL_CONFIGS_SUCCESS,
    payload: response,
  };
}

export function getEmailClientsRequest() {
  return {
    type: types.GET_EMAIL_CLIENTS_REQUEST,
  };
}

export function getEmailClientsSuccess(clients) {
  return {
    type: types.GET_EMAIL_CLIENTS_SUCCESS,
    payload: clients,
  };
}

export function getEmailClientsFailure(response) {
  return {
    type: types.GET_EMAIL_CLIENTS_FAILED,
    payload: response,
  };
}


// PARTNER CONFIG CLAIM
export function getPartnerConfigsClaimRequest(payload) {
  return {
    type: types.GET_PARTNER_CONFIGS_CLAIM_REQUEST,
    payload,
  };
}

export function getPartnerConfigsClaimFailure(error) {
  return {
    type: types.GET_PARTNER_CONFIGS_CLAIM_FAILURE,
    payload: error,
  };
}

export function getPartnerConfigsClaimSuccess(response) {
  return {
    type: types.GET_PARTNER_CONFIGS_CLAIM_SUCCESS,
    payload: response,
  };
}

// PARTNER CONFIG GROUP
export function getPartnerConfigsGroupRequest(payload) {
  return {
    type: types.GET_PARTNER_CONFIGS_GROUP_REQUEST,
    payload,
  };
}

export function getPartnerConfigsGroupFailure(error) {
  return {
    type: types.GET_PARTNER_CONFIGS_GROUP_FAILURE,
    payload: error,
  };
}

export function getPartnerConfigsGroupSuccess(response) {
  return {
    type: types.GET_PARTNER_CONFIGS_GROUP_SUCCESS,
    payload: response,
  };
}



// update PARTNER
export function updatePartnerRequest(payload) {
  return {
    type: types.UPDATE_PARTNER_REQUEST,
    payload,
  };
}

export function updatePartnerFailure(error) {
  return {
    type: types.UPDATE_PARTNER_FAILURE,
    payload: error,
  };
}

export function updatePartnerSuccess(response) {
  return {
    type: types.UPDATE_PARTNER_SUCCESS,
    payload: response,
  };
}

export function resetUpdatePartnerSuccess(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_SUCCESS,
  };
}

export function resetUpdatePartnerError(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_ERROR,
  };
}

// update PARTNER CONFIG
export function updatePartnerConfigRequest(payload) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_REQUEST,
    payload,
  };
}

export function updatePartnerConfigFailure(error) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_FAILURE,
    payload: error,
  };
}

export function updatePartnerConfigSuccess(response) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_SUCCESS,
    payload: response,
  };
}


export function resetUpdatePartnerConfigSuccess(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_CONFIG_SUCCESS,
  };
}

export function resetUpdatePartnerConfigError(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_CONFIG_ERROR,
  };
}



// update PARTNER CONFIG EMAIL
export function updatePartnerConfigEmailRequest(payload) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_EMAIL_REQUEST,
    payload,
  };
}

export function updatePartnerConfigEmailFailure(error) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_EMAIL_FAILURE,
    payload: error,
  };
}

export function updatePartnerConfigEmailSuccess(response) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_EMAIL_SUCCESS,
    payload: response,
  };
}

export function resetUpdatePartnerConfigEmailSuccess(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_CONFIG_EMAIL_SUCCESS,
  };
}

export function resetUpdatePartnerConfigEmailError(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_CONFIG_EMAIL_ERROR,
  };
}


// update PARTNER CONFIG CLAIM
export function updatePartnerConfigClaimRequest(payload) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_CLAIM_REQUEST,
    payload,
  };
}

export function updatePartnerConfigClaimFailure(error) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_CLAIM_FAILURE,
    payload: error,
  };
}

export function updatePartnerConfigClaimSuccess(response) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_CLAIM_SUCCESS,
    payload: response,
  };
}

export function resetUpdatePartnerConfigClaiimSuccess(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_CONFIG_CLAIM_SUCCESS,
  };
}

export function resetUpdatePartnerConfigClaiimError(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_CONFIG_CLAIM_ERROR,
  };
}

// SMS CHANNEL CONFIG
export function getPartnerSmsChannelsRequest() {
  return { type: types.GET_PARTNER_SMS_CHANNELS_REQUEST };
}
export function getPartnerSmsChannelsSuccess(response) {
  return { type: types.GET_PARTNER_SMS_CHANNELS_SUCCESS, payload: response };
}
export function getPartnerSmsChannelsFailure(error) {
  return { type: types.GET_PARTNER_SMS_CHANNELS_FAILURE, payload: error };
}

export function saveSmsChannelRequest(payload) {
  return { type: types.SAVE_SMS_CHANNEL_REQUEST, payload };
}
export function saveSmsChannelSuccess(response) {
  return { type: types.SAVE_SMS_CHANNEL_SUCCESS, payload: response };
}
export function saveSmsChannelFailure(error) {
  return { type: types.SAVE_SMS_CHANNEL_FAILURE, payload: error };
}
export function resetSaveSmsChannelSuccess() {
  return { type: types.RESET_SAVE_SMS_CHANNEL_SUCCESS };
}
export function resetSaveSmsChannelError() {
  return { type: types.RESET_SAVE_SMS_CHANNEL_ERROR };
}

export function deleteSmsChannelRequest(payload) {
  return { type: types.DELETE_SMS_CHANNEL_REQUEST, payload };
}
export function deleteSmsChannelSuccess(response) {
  return { type: types.DELETE_SMS_CHANNEL_SUCCESS, payload: response };
}
export function deleteSmsChannelFailure(error) {
  return { type: types.DELETE_SMS_CHANNEL_FAILURE, payload: error };
}
export function resetDeleteSmsChannelSuccess() {
  return { type: types.RESET_DELETE_SMS_CHANNEL_SUCCESS };
}
export function resetDeleteSmsChannelError() {
  return { type: types.RESET_DELETE_SMS_CHANNEL_ERROR };
}

export function testSmsChannelRequest(payload) {
  return { type: types.TEST_SMS_CHANNEL_REQUEST, payload };
}
export function testSmsChannelSuccess(response) {
  return { type: types.TEST_SMS_CHANNEL_SUCCESS, payload: response };
}
export function testSmsChannelFailure(error) {
  return { type: types.TEST_SMS_CHANNEL_FAILURE, payload: error };
}
export function resetTestSmsChannel() {
  return { type: types.RESET_TEST_SMS_CHANNEL };
}

// POLICY MAKER CHECKS (AML / maker-checker sequence)
export function getPolicyMakerChecksRequest() {
  return { type: types.GET_POLICY_MAKER_CHECKS_REQUEST };
}
export function getPolicyMakerChecksSuccess(response) {
  return { type: types.GET_POLICY_MAKER_CHECKS_SUCCESS, payload: response };
}
export function getPolicyMakerChecksFailure(error) {
  return { type: types.GET_POLICY_MAKER_CHECKS_FAILURE, payload: error };
}

export function savePolicyMakerCheckRequest(payload) {
  return { type: types.SAVE_POLICY_MAKER_CHECK_REQUEST, payload };
}
export function savePolicyMakerCheckSuccess(response) {
  return { type: types.SAVE_POLICY_MAKER_CHECK_SUCCESS, payload: response };
}
export function savePolicyMakerCheckFailure(error) {
  return { type: types.SAVE_POLICY_MAKER_CHECK_FAILURE, payload: error };
}
export function resetSavePolicyMakerCheckSuccess() {
  return { type: types.RESET_SAVE_POLICY_MAKER_CHECK_SUCCESS };
}
export function resetSavePolicyMakerCheckError() {
  return { type: types.RESET_SAVE_POLICY_MAKER_CHECK_ERROR };
}

export function deletePolicyMakerCheckRequest(payload) {
  return { type: types.DELETE_POLICY_MAKER_CHECK_REQUEST, payload };
}
export function deletePolicyMakerCheckSuccess(response) {
  return { type: types.DELETE_POLICY_MAKER_CHECK_SUCCESS, payload: response };
}
export function deletePolicyMakerCheckFailure(error) {
  return { type: types.DELETE_POLICY_MAKER_CHECK_FAILURE, payload: error };
}
export function resetDeletePolicyMakerCheckSuccess() {
  return { type: types.RESET_DELETE_POLICY_MAKER_CHECK_SUCCESS };
}
export function resetDeletePolicyMakerCheckError() {
  return { type: types.RESET_DELETE_POLICY_MAKER_CHECK_ERROR };
}

export function saveChannelResolutionRequest(payload) {
  return { type: types.SAVE_CHANNEL_RESOLUTION_REQUEST, payload };
}
export function saveChannelResolutionSuccess(response) {
  return { type: types.SAVE_CHANNEL_RESOLUTION_SUCCESS, payload: response };
}
export function saveChannelResolutionFailure(error) {
  return { type: types.SAVE_CHANNEL_RESOLUTION_FAILURE, payload: error };
}
export function resetSaveChannelResolutionSuccess() {
  return { type: types.RESET_SAVE_CHANNEL_RESOLUTION_SUCCESS };
}
export function resetSaveChannelResolutionError() {
  return { type: types.RESET_SAVE_CHANNEL_RESOLUTION_ERROR };
}

// update PARTNER CONFIG CLAIM
export function updatePartnerConfigGroupRequest(payload) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_GROUP_REQUEST,
    payload,
  };
}

export function updatePartnerConfigGroupFailure(error) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_GROUP_FAILURE,
    payload: error,
  };
}

export function updatePartnerConfigGroupSuccess(response) {
  return {
    type: types.UPDATE_PARTNER_CONFIG_GROUP_SUCCESS,
    payload: response,
  };
}

export function resetUpdatePartnerConfigGroupSuccess() {
  return {
    type: types.RESET_UPDATE_PARTNER_CONFIG_GROUP_SUCCESS,
  };
}

export function resetUpdatePartnerConfigGroupError(error) {
  return {
    type: types.RESET_UPDATE_PARTNER_CONFIG_GROUP_ERROR,
  };
}